import React, {Component} from 'react';
const { connect } = require('react-redux');

import {t} from 'l10n';

import {memberDisableMyGuestbook} from 'reducers/member';

class DisableMyGuestbook extends Component {
    render() {
        let {currentUser, memberDisableMyGuestbook} = this.props;

        return (
            <div className="checkbox disable-my-guestbook">
                <input
                    type="checkbox"
                    name="guestbook_disabled"
                    id="member_guestbook_disabled"
                    defaultChecked={currentUser.guestbook_disabled}
                    onChange={(e) => memberDisableMyGuestbook(e.target.checked)}
                />
                <label htmlFor="member_guestbook_disabled">{t('Disable my guestbook')}</label>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        currentUser: state.currentUser
    }),
    {
        memberDisableMyGuestbook: memberDisableMyGuestbook
    }
)(DisableMyGuestbook);


// WEBPACK FOOTER //
// ./src/components/guestbook/DisableMyGuestbook.js